var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-avatar',{attrs:{"height":_vm.height,"width":_vm.width}},[(_vm.profileAvatar)?_c('v-img',{attrs:{"src":_vm.profileAvatar,"alt":"avatar"}}):_c('v-icon',{staticStyle:{"background":"white"}},[_vm._v("fas fa-user")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }